import { get, type Writable } from 'svelte/store'
import { t } from 'svelte-i18n'
import type { ToastModel } from '@repo/commons/models'
import { ToastType } from '@repo/commons/components'
import { toastsStore } from '@repo/commons/store'
import { generateId } from '@repo/commons/utils'

export const showToast = (
	toastsStore: Writable<ToastModel[]>,
	customToast: Partial<ToastModel> = {}
): string => {
	const id: string = generateId()
	const defaultToast: ToastModel = {
		id: id,
		type: ToastType.INFO,
		dismissible: true,
		timeout: 3000, // Default timeout
		message: 'Default toast message'
	}
	const finalToast: ToastModel = { ...defaultToast, ...customToast, id } // Ensure id is not overwritten

	// Use user-defined timeout if provided, otherwise calculate dynamically
	finalToast.timeout = customToast.timeout ?? Math.max(4000, (finalToast.message?.length || 0) * 20)
	toastsStore.update((all) => [...all, finalToast])

	if (finalToast.timeout) {
		setTimeout(() => dismissToast(toastsStore, id), finalToast.timeout)
	}

	return id
}

export const dismissToast = (toastsStore: Writable<ToastModel[]>, id: string) => {
	toastsStore.update((all) => all.filter((t: ToastModel) => t.id !== id))
}

export const showErrorToast = (message: string): void => {
	showToast(toastsStore, { type: ToastType.ERROR, message })
}

export const showSaveFailedToast = (): void => {
	showErrorToast(get(t)('Toast.saveFailed'))
}
